import React from 'react';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { TemplateModal } from '../TemplateModal/TemplateModal';

type Props = {
  templateId: number;
  onClose: () => any;
  onRemove: (id: number) => any;
};

export const AreYouSureToRemoveTemplate = ({
  onRemove,
  templateId,
  onClose,
}: Props) => {
  const onRemoveClick = () => {
    onRemove && onRemove(templateId);
    onClose && onClose();
  };

  return (
    <TemplateModal isOpen={true}>
      <TemplateModal.Header toggle={onClose}>
        Are you sure you want to delete this template?
      </TemplateModal.Header>
      <TemplateModal.Body>
        <TemplateModal.Footer>
          <Button link onClick={onClose}>
            Cancel
          </Button>
          <Button blue type="submit" onClick={onRemoveClick}>
            Yes
          </Button>
        </TemplateModal.Footer>
      </TemplateModal.Body>
    </TemplateModal>
  );
};
